import React, { useState } from 'react';
import { Icon, Text, Tooltip } from '@perch-labs/shrike';
import { Container, Card } from 'styles';
import { copyFor } from 'config';
import { SPONSORED_SOLAR } from 'pages/dashboard/dashboard.utils';

const getCopy = copyFor('solar.projectDetails');

export interface Props {
  description?: string;
  imageSrc?: string;
  svgSrc?: string;
  location: string;
  title: string;
  margin?: Margin;
  mdIdentifier: string | null;
  originationSourceType?: string;
}

export const ProjectDetails: React.FC<Props> = props => {
  const {
    title,
    description,
    location,
    imageSrc: defaultImage,
    svgSrc: customImage,
    children,
    margin,
    mdIdentifier,
    originationSourceType,
  } = props;

  const imageLink = customImage || defaultImage;
  const [displayImage, setDisplayImage] = useState(imageLink);
  const showDefaultImage = () => setDisplayImage(defaultImage);
  const getCopy = copyFor('solar.projectDetails');
  const sponsoredSolar = originationSourceType === SPONSORED_SOLAR;

  return (
    <Card mobileVariant="flat" margin={margin}>
      <Card.Header>
        <Container>
          <Text
            textStyle="heading700"
            tag="h2"
            margin={{ bottom: '8px', right: '8px' }}
          >
            {sponsoredSolar
              ? getCopy('pending.sponsoredSolarTitle')
              : title.replace('Solar Farm', '')}
          </Text>
          <Container flex alignItems="center">
            <Icon icon="Location" opacity="medium" />
            <Text
              margin={{ left: '8px' }}
              opacity="medium"
              textStyle="paragraph400"
            >
              {location}
            </Text>
          </Container>
          <ShowMdIdentifier mdIdentifier={mdIdentifier} />
        </Container>
        <img
          alt="solar farm"
          src={displayImage}
          width="109"
          style={{ borderRadius: '8px' }}
          onError={showDefaultImage}
        />
      </Card.Header>
      <Card.Content>
        {description && (
          <Text margin={{ bottom: '32px', top: '16px' }}>{description}</Text>
        )}
        {children}
      </Card.Content>
    </Card>
  );
};

function ShowMdIdentifier({ mdIdentifier }) {
  if (!mdIdentifier) return null;
  return (
    <Container flex alignItems="center" margin={{ top: '8px' }}>
      <Text opacity="medium" textStyle="paragraph400" margin={{ right: '8px' }}>
        {getCopy('mdIdentifier.labelledSON', { mdIdentifier })}
      </Text>
      <Tooltip
        content={getCopy('mdIdentifier.tooltipContent')}
        tooltipId="SON"
        label={getCopy('mdIdentifier.tooltipLabel')}
      >
        <Icon icon="InfoCircleInverted" opacity="medium" />
      </Tooltip>
    </Container>
  );
}
